import { createStore } from "zustand";

type CaseBlocksConfigState = {
  selectedBlockId: string | null;
};

type CaseBlocksConfigActions = {
  selectBlock: (id: string | null) => void;
};

type CaseBlocksConfigStore = ZustandStore<
  CaseBlocksConfigState,
  CaseBlocksConfigActions
>;

export const createCaseBlocksConfigStore = () =>
  createStore<CaseBlocksConfigStore>((set) => ({
    selectedBlockId: null,
    actions: {
      selectBlock: (id) => set({ selectedBlockId: id }),
    },
  }));
